// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"71d1e0e0","413":"34ebe8f7","963":"2db4314a"}[chunkId] + ".chunk.js";
};